import PostList from "./PostList";
import "semantic-ui-css/semantic.min.css";

const App = () => {
  return (
    <div className="ui container">
      <PostList />
    </div>
  );
}

export default App;
